import { Fragment, useMemo, useState } from "react";
import { useDataFetch } from "../../Hooks/Use-data-fetch";
import DataTable from "../../Components/DataTable";
import { createColumnHelper } from "@tanstack/react-table";
import { StatusChip } from "../../Components/common/StatusChip";
import { PageHeader } from "../../Components/common/PageHeader";

export const SubscriberList = () => {
  const { getData } = useDataFetch();

  const { data, isLoading } = getData(
    ["subscribers"],
    "/subscribers",
    {
      enabled: true,
    }
  );

  const columnHelper = createColumnHelper();

  const columns = useMemo(() => [
    columnHelper.accessor("name", { header: "Nombre" }),
    columnHelper.accessor("email", { header: "Correo" }),
    columnHelper.accessor("state", {
      header: "Estado",
      cell: info => {
        const state = info.getValue();
        return <StatusChip tone={state ? "success" : "neutral"}>{state ? "Activo" : "Inactivo"}</StatusChip>;
      }
    }),
    columnHelper.accessor("created_at", {
      header: "Fecha",
      cell: info => {
        const rawDate = info.getValue();
        const date = new Date(rawDate);
        return date.toLocaleDateString();
      }
    }),
  ], [columnHelper]);

  const subscribers = data?.data?.subscribers ?? [];

  // `/subscribers` no pagina en el backend: pagina en cliente sobre lo ya
  // cargado, sin duplicar el fetch.
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10 });
  const pageData = subscribers.slice(
    pagination.pageIndex * pagination.pageSize,
    (pagination.pageIndex + 1) * pagination.pageSize
  );

  return (
    <Fragment>
      <PageHeader title="Suscriptores" crumbs={[{ label: "Usuarios" }, { label: "Suscriptores" }]} />

      <DataTable
        data={pageData}
        total={subscribers.length}
        pagination={pagination}
        setPagination={setPagination}
        columns={columns}
        progressPending={isLoading}
        emptyMessage="No hay suscriptores para mostrar."
      />
    </Fragment>
  );
}
